/* eslint-disable no-duplicate-case */
import dom from '../lib/dom';
import Swiper from '../custom/swiper';
import Responsive from '../lib/responsive';
import {trigger} from '../lib/event';
import {toArray} from 'lodash';
import {elHTML} from '../config/vars';

export default class LightBox {
  constructor(el) {

    if (!el) {

      return;
    }

    this.videoBox = el.classList.contains('tc-video-box') ? true : false;
    this.isMobile = elHTML.classList.contains('touchevents');

    /**
     * if it's light-box photos
     */
    if (!this.videoBox) {

      this.content = el;
      this.currentImage = 0;
      this.isMobileScroll = false;
      this.breakpoints = Responsive.getBreakpoint();
      this.screenshots = toArray(this.content.querySelectorAll('.screenshot .lazy-loading-image'));
      this.images = this.screenshots.map(el => {

        const image = el.dataset.lbImage;
        const index = el.dataset.lbIndexz;
        let resolution;
        let url;

        switch (this.breakpoints) {
          case 'xxl':
          case 'xl':
            resolution = '1280x0';
            break;
          case 'l':
          case 'm':
            resolution = '768x0';
            break;
          case 's':
          case 'xs':
            resolution = '480x0';
            break;
          default:
            resolution = '1280x0';
            break;
        }
        if (/m[1-9][0-9]\.dvdl\.net/.test(image)) {

          url = this.addResolutionMxx(image, resolution);
        } else if (/cob[1-9][0-9]\.dvdl\.net/.test(image)) {

          url = this.addResolutionCobXX(image, resolution);
        } else {

          url = image;
        }

        return {url, index};
      });

    } else {

      this.trailerTriggerButton = el;
      this.content = document.getElementById(el.dataset.sceneId);
      this.sceneVideoUrl = el.dataset.sceneUrl;
    }
    this.initializeDom();
  }

  /**
   * initialize DOM overlay and content inside
   */
  initializeDom() {

    const containerElements = [];

    this.closeIcon = dom.create('i', {
      class: 'i-close'
    }, []);

    containerElements.push(dom.create(
      'span',
      {class: 'light-box-swiper__close'},
      [this.closeIcon]
    ));

    if (!this.videoBox) {

      const slides = [];
      const withGallery = !this.isMobile ? ' with-gallery' : '';
      for (let i = 0; i < this.images.length; i++) {

        const slideImage = dom.create('img', {}, []);
        slides.push(dom.create('div', {class: 'swiper-slide'}, [slideImage]));
      }

      if (!this.isMobile) {

        this.slidesGallery = [];
        let gallerySlideClass;

        if (this.screenshots.length <= 12) {
          gallerySlideClass = 'items-12';
        } else {
          gallerySlideClass = 'items-24';
        }

        for (let j = 0; j < this.screenshots.length; j++) {

          const src = this.screenshots[j].childNodes[3].src;
          this.slidesGallery.push(dom.create('div', {
            class: `gallery-slide ${gallerySlideClass}`,
            style: `background-image:url(${src});`,
            'data-goto': j
          }, []));
        }

        this.GalleryWrapper = dom.create('div', {
          class: `swiper-gallery ${gallerySlideClass}`
        }, this.slidesGallery);

        this.galleryThumbs = dom.create('div', {
          class: `gallery-thumbs ${gallerySlideClass}`
        }, [this.GalleryWrapper]);

        containerElements.push(this.galleryThumbs);
      }

      this.swiperWrapper = dom.create('div', {
        class: 'swiper-wrapper'
      }, slides);

      this.swiperButtonPrev = dom.create('div', {
        class: `lb-prev ${withGallery} swiper-button-prev i-arrow-next-circled`
      }, []);

      this.swiperButtonNext = dom.create('div', {
        class: `lb-next ${withGallery} swiper-button-next i-arrow-prev-circled`
      }, []);

      this.contentContainer = dom.create('div', {
        class: `overlay-content light-box-swiper ${withGallery}`
      }, [this.swiperWrapper]);

      containerElements.push(this.swiperButtonNext);
      containerElements.push(this.swiperButtonPrev);
      containerElements.push(this.contentContainer);

      this.swiperContainer = this.contentContainer;
      this.swiperOptions = {
        nextButton: this.swiperButtonPrev,
        prevButton: this.swiperButtonNext,
        spaceBetween: 30,
        centeredSlides: true,
        simulateTouch: true,
        initialSlide: this.currentImage,
        onSlideChangeStart: this.onSlideChangeStart,
        onSlideNextStart: this.handleSlidePrevNext.bind(this),
        onSlidePrevStart: this.handleSlidePrevNext.bind(this)
      };

      this.swiper = new Swiper(this.swiperContainer, this.swiperOptions);
    } else {

      containerElements.push(this.content);
    }

    this.container = dom.create('div', {
      class: 'overlay-container'
    }, containerElements);

    this.overlay = dom.create('div', {
      class: 'overlay-backdrop'
    }, [this.container]);

    document.body.appendChild(this.overlay);

    this.registerEvents();
  }

  /**
   * register events for lightbox
   */
  registerEvents() {

    if (!this.videoBox) {

      this.screenshots.forEach(el => {
        el.addEventListener('click', this.open.bind(this));
      });

      if (!this.isMobile) {

        this.slidesGallery.forEach(el => {

          el.addEventListener('click', (event) => {

            this.swiper.slideTo(event.target.dataset.goto, 0);
            this.swiper.update();
          });
        });
      }

    } else {

      this.trailerTriggerButton.addEventListener('click', this.open.bind(this));
    }

    window.addEventListener('keydown', this.closeOnEsc.bind(this));

    if (this.closeIconWrapper) {

      this.closeIconWrapper.addEventListener('click', this.close.bind(this));
    }

    this.overlay.addEventListener('click', this.onBackdropClick.bind(this));
  }

  /**
   * Handle lazy load when we slideTo next/prev slide
   * @param {object} swiper
   */
  handleSlidePrevNext(swiper) {

    this.lazyImgSrcUpdate(swiper.activeIndex, swiper.slides);
  }

  /**
   * open lightbox for video or photos
   * @param {event} e
   */
  open(e) {

    if (e && e.preventDefault) {

      e.preventDefault();
    }

    if (!this.videoBox) {

      if (this.isMobile && this.isMobileScroll) {

        this.isMobileScroll = false;
        // return;
      }

      this.currentImage = e.target.parentNode.dataset.lbIndex;
      this.swiper.slides[this.currentImage].childNodes[0].src = this.images[this.currentImage].url;
      this.lazyImgSrcUpdate(this.currentImage, this.swiper.slides);

      this.swiper.update();
      this.swiper.slideTo(this.currentImage, 0);

      this.overlay.classList.add('is-bound');
      trigger(document, 'tc-overlay-open');

      this.swiper.update();
      this.swiper.slideTo(this.currentImage, 0);
    } else {

      this.content.childNodes[1].classList.remove('light-box-init');

      this.content.classList.add('is-open');

      this.overlay.classList.add('is-bound');
      trigger(document, 'tc-overlay-open');
    }
  }

  /**
   * close Lightbox on ESC press
   * @param {event} e
   */

  closeOnEsc(e) {

    if (e.key === 'Escape') {

      this.close(e);
    }
  }

  /**
   * Lazy load 2 images before and after current image.
   * @param {number} index
   * @param {array} sliders
   */
  lazyImgSrcUpdate(index, sliders) {

    for (let i = index - 2; i <= index + 2; i++) {

      if (sliders[i] && !sliders[i].childNodes[0].src) {

        sliders[i].childNodes[0].src = this.images[i].url;
      }
    }
  }

  /**
   * close Lightbox
   * @param {event} e
   */
  close(e) {

    if (e && e.preventDefault) {

      e.preventDefault();
    }

    if (!this.videoBox) {

      this.swiper.update();
    } else {

    }

    this.overlay.classList.remove('is-bound');
    trigger(document, 'tc-overlay-close');
  }

  /**
   * Close lightbox on backdrop shadow click
   * @param {event} e
   */
  onBackdropClick(e) {

    if (e.target === this.container || e.target === this.closeIcon || e.target === this.galleryThumbs) {
      window.setTimeout(() => {
        this.close(e);
      }, 100);
    }
  }

  /**
   * Add specific resolution to M1 or Cob1 CDN url
   * @param {string} url
   * @param {resolutin} value
   */
  addResolutionMxx(url, value) {

    return `${url.substring(0, 20)}/rsz${url.substring(20, url.lastIndexOf('/'))}/${value}${url.substring(url.lastIndexOf('/'), url.length)}`;
  }

  addResolutionCobXX(url, value) {

    return `${url.substring(0, 22)}/${value}${url.substring(22, url.length)}`;
  }
};
